<div *ngIf="showText" class="text">Page {{ currentPage }} of {{ pageCount }}</div>
<div class="page-container">
  <button
    *ngIf="currentPage > 1"
    type="button"
    class="button button--start"
    [ngClass]="{ 'button--light': lightStyle }"
    [disabled]="currentPage === 1"
    (click)="onPreviousPage()"
  ></button>

  <a
    *ngIf="showFirstPage"
    class="page"
    [ngClass]="{ 'page--light': lightStyle }"
    (click)="selectPage(1)"
  >
    1
  </a>

  <span *ngIf="showStartDots" class="text-medium-small">...</span>

  <a
    *ngFor="let page of pages"
    class="page"
    [ngClass]="{ 'page--selected': page.isSelected, 'page--light': lightStyle }"
    (click)="selectPage(page.number)"
    >{{ page.number }}</a
  >

  <span *ngIf="showEndDots" class="text-medium-small">...</span>

  <a
    *ngIf="showLastPage"
    class="page"
    [ngClass]="{ 'page--light': lightStyle }"
    (click)="selectPage(+pageCount)"
  >
    {{ pageCount }}
  </a>

  <button
    *ngIf="currentPage < pageCount"
    type="button"
    class="button"
    [ngClass]="{ 'button--light': lightStyle }"
    [disabled]="currentPage === pageCount"
    (click)="onNextPage()"
  ></button>
</div>
